interface SubjectData {
  subject: string
  nStudents: number | null
  avgScore: number | null
  pStudents: number
  recalibration: string
}

const examYearMapping = {
  'United States Government and Politics': 2024,
  'United States History': 2024,
  'European History': 2024,
  Macroeconomics: 2023,
  Microeconomics: 2023,
  Chemistry: 2023,
  'World History: Modern': 2022,
  'English Literature and Composition': 2022,
  Biology: 2022,
}

const recalibratedExams = Object.keys(examYearMapping)

const recalibratedExamsIn2324 = [
  'Microeconomics',
  'Macroeconomics',
  'Chemistry',
  'United States Government and Politics',
  'United States History',
  'European History',
]

export function transformApData(raw: any, apExamYear: string) {
  if (!raw) return []

  const result: Record<number, any[]> = { '2022': [], '2023': [], '2024': [] }
  const exams = raw.getApContextData.ap_exams

  exams.forEach((exam) => {
    let nStudents = null
    let avgScore = null
    let pStudents = 0
    exam.ap_exam_display_cohorts
      .filter((cohort) => cohort.parent_ed_lvl_flag_combo.includes('All'))
      .forEach((cohort) => {
        const scoreDetails = {}
        nStudents = cohort.cohort_students_cn
        avgScore = cohort.cohort_recalibration_avg_score
        pStudents =
          cohort.cohort_students_pct < 1
            ? cohort.cohort_students_pct
            : Math.round(cohort.cohort_students_pct)
        cohort.score_cohorts.forEach((score) => {
          scoreDetails[score.max_ap_score] = score.recalibration_score_student_pct
        })
        const newSubject: SubjectData = {
          subject: recalibratedExamsIn2324.includes(exam.ap_exam_name)
            ? `${exam.ap_exam_name}*`
            : exam.ap_exam_name,
          nStudents: nStudents,
          avgScore: avgScore,
          pStudents: pStudents,
          recalibration: cohort.recalibration,
          ...scoreDetails,
        }
        if (!result[apExamYear]) {
          result[apExamYear] = []
        }
        const isRecalibrated = recalibratedExams.includes(exam.ap_exam_name)
        const isCalibratedBeforeSelectedYear = apExamYear >= examYearMapping[exam.ap_exam_name]
        let shouldAcceptThisCohort =
          (!isRecalibrated && cohort.recalibration == 0) || // Not calibrated, accept the cohort
          (isRecalibrated && isCalibratedBeforeSelectedYear && cohort.recalibration == 1) || // Exam is recalibrated in or before the selected year, accept the cohort with recalibration 1
          (isRecalibrated && !isCalibratedBeforeSelectedYear && cohort.recalibration == 0) // Exam is recalibrated after the selected year, accept the cohort with recalibration 0

        if (
          Number(apExamYear) < 2024 &&
          (exam.ap_exam_name === 'African American Studies' || exam.ap_exam_name === 'Precalculus')
        ) {
          shouldAcceptThisCohort = false
        }

        if (shouldAcceptThisCohort) {
          // Accept this cohort if any of the above conditions are true, else discard it and move to the next cohort data set
          result[apExamYear].push(newSubject)
        }
      })
  })

  return result[apExamYear]
}
